import { render } from "./ProjectEditor.vue?vue&type=template&id=61819fee&scoped=true&ts=true"
import script from "./ProjectEditor.vue?vue&type=script&lang=ts"
export * from "./ProjectEditor.vue?vue&type=script&lang=ts"

import "./ProjectEditor.vue?vue&type=style&index=0&id=61819fee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61819fee"]])

export default __exports__